module.exports = __webpack_public_path__ + "static/media/2022-Bikie-Code-Feature-banner-Tablet@1x.576baf19.jpg";